import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { LIST_GROUP_ACTIONS } from '@usf/ngrx-list';
import { tap } from 'rxjs/operators';
import { MessageTypeEnum } from '../../../ngrx-message/constants/messageTypeEnum';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner/loading-spinner.service';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ClientListGroupEffects {
  /* Create group success */
  createGroupSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LIST_GROUP_ACTIONS.createSuccess),
        tap(action => {
          this.loadingSpinnerService.dismissSpinnerModal().then(() => {
            if (action.newGroupNumber) {
              document
                .getElementById('list-groups-button-' + action.newGroupNumber)
                .scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                });
            }
          });
        }),
      ),
    { dispatch: false },
  );

  /* Edit group name success*/
  editGroupNameSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LIST_GROUP_ACTIONS.editGroupNameSuccess),
        tap(action => {
          this.loadingSpinnerService.dismissSpinnerModal();
        }),
      ),
    { dispatch: false },
  );

  /* Move items success */
  moveItemsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          LIST_GROUP_ACTIONS.moveItemsToAnotherGroupSuccess,
          LIST_GROUP_ACTIONS.moveItemsWithinGroupSuccess,
        ),
        tap(action => {
          this.loadingSpinnerService.dismissSpinnerModal();
          let display;
          if (action.numberOfItemsMoved === 1) {
            display = this.translateService.instant(
              'i18n.lists.moveItemSuccess',
            );
          } else {
            display = this.translateService.instant(
              'i18n.lists.moveItemsSuccess',
              { numberOfItemsMoved: action.numberOfItemsMoved },
            );
          }
          this.toastService.presentToastMsg(
            display,
            'green-toast',
            MessageTypeEnum.success,
            [],
          );
        }),
      ),
    { dispatch: false },
  );

  /* Create group, resequence items, edit group name or moveItemsToAnother group failed */
  domainCallFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          LIST_GROUP_ACTIONS.moveItemsWithinGroupFail,
          LIST_GROUP_ACTIONS.moveItemsToAnotherGroupFail,
          LIST_GROUP_ACTIONS.createFail,
          LIST_GROUP_ACTIONS.editGroupNameFail,
        ),
        tap(action => {
          this.loadingSpinnerService.dismissSpinnerModal();
          this.toastService.presentToastMsg(
            this.translateService.instant('i18n.lists.genericError'),
            'red-toast',
            MessageTypeEnum.error,
            [],
          );
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private loadingSpinnerService: LoadingSpinnerService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}
}
